/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { typography2 } from '@coursera/cds-core';

import BaseMarkdown from 'bundles/cms/components/Markdown';

type Props = { source?: string | null };

const styles = {
  markdown: css`
    ${typography2.bodyPrimary}

    p {
      font: ${typography2.bodyPrimary.font} !important;
      letter-spacing: ${typography2.bodyPrimary.letterSpacing} !important;
      margin-bottom: unset !important;
    }
  `,
};

const Markdown = ({ source, ...rest }: Props) => {
  if (!source) {
    return null;
  }

  return <BaseMarkdown source={source} css={styles.markdown} {...rest} />;
};

export default Markdown;
